export default "__VITE_ASSET__0b5d8771__"